import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c5-five-one-three-one',
  templateUrl: './c5-five-one-three-one.component.html',
  styleUrls: ['./c5-five-one-three-one.component.scss']
})
export class C5FiveOneThreeOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
